import type { CityConfig } from "@/pages/city-template/types";

export const shawneeKsConfig: CityConfig = {
  city: "Shawnee",
  state: "Kansas",
  stateAbbr: "KS",
  slug: "shawnee-ks",
  route: "/cities/shawnee-ks",
  title: "Emergency Passport Shawnee, KS | Fast Passport Renewal & Expedited Services | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Shawnee, KS — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Shawnee and Johnson County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Shawnee, Kansas",
  heroSubtitle: "Passport expired before your trip to Europe? Flying out of MCI in days? Need a child passport for a school trip? Fast Passport Center helps Shawnee, Kansas travelers get their passports fast — as fast as 24 hours. A+ BBB rated. No office visit required for most services.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Shawnee%20Kansas%20scenic%20suburban%20landscape%20with%20Shawnee%20Mission%20Park%20lake%20and%20tree-lined%20walking%20trails%2C%20historic%20Old%20Shawnee%20Town%20buildings%20and%20charming%20downtown%20district%2C%20Johnson%20County%20residential%20neighborhoods%20with%20mature%20trees%2C%20warm%20golden%20hour%20sunlight%20with%20amber%20and%20sage%20tones%2C%20peaceful%20Midwest%20suburban%20aesthetic%2C%20photorealistic%20drone%20photography&width=1800&height=700&seq=shawnee-ks-hero-2026&orientation=landscape",
  heroImageAlt: "Shawnee Kansas suburban landscape with Shawnee Mission Park and historic downtown district",
  geoPosition: "39.0228;-94.7152",
  geoPlacename: "Shawnee, Kansas",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Arkansas Passport Center",
    address: "191 Office Park Dr, Hot Springs, AR 71913",
    distance: "About 370 miles south — approximately 5.5 hours by car",
  },
  nearbyCitiesZips: [
    { name: "Shawnee", zips: "66203–66226" },
    { name: "Lenexa", zips: "66214–66227" },
    { name: "Merriam", zips: "66202–66204" },
    { name: "Overland Park", zips: "66204–66225" },
    { name: "Olathe", zips: "66051–66063" },
    { name: "Prairie Village", zips: "66206–66208" },
    { name: "Mission", zips: "66201–66222" },
    { name: "Leawood", zips: "66206–66211" },
    { name: "Kansas City", zips: "66101–66160" },
    { name: "Lake Quivira", zips: "66217" },
    { name: "Bonner Springs", zips: "66012" },
    { name: "Edwardsville", zips: "66111–66113" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from your Shawnee home or office in minutes." },
    { icon: "ri-truck-line", title: "Ship Overnight from Shawnee", desc: "FedEx and UPS locations throughout Shawnee and Johnson County offer overnight shipping to our processing center." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and delays — especially important for last-minute passport needs." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport center — no public appointment hunting needed." },
  ],
  testimonials: [
    {
      name: "Jennifer R.",
      location: "Shawnee, KS",
      rating: 5,
      text: "Our family trip to Ireland was in 8 days when we realized both kids' passports were expired. Fast Passport Center walked us through everything — we shipped from UPS on Shawnee Mission Parkway and had all passports back in 6 days. Incredible service.",
      service: "Child Passport",
    },
    {
      name: "Tom H.",
      location: "Shawnee, KS",
      rating: 5,
      text: "Got called for a last-minute business trip to Germany and my passport had 2 months left before expiry. Fast Passport Center renewed it in 4 days. Shipped from FedEx on Johnson Drive — couldn't have been easier.",
      service: "Passport Renewal",
    },
    {
      name: "Lisa M.",
      location: "Lake Quivira, KS",
      rating: 5,
      text: "Lost my passport 10 days before our anniversary cruise out of Miami. Fast Passport Center handled the replacement and I had my new passport in 7 days. The dedicated agent kept me updated daily.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "shawnee-ks-main-post",
      name: "Shawnee Post Office",
      type: "USPS Passport Acceptance",
      address: "10601 Shawnee Mission Pkwy",
      city: "Shawnee",
      state: "KS",
      zip: "66203",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Central Shawnee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance location in Shawnee. Appointment required — book online well in advance. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "shawnee-ks-merriam-post",
      name: "Merriam Post Office",
      type: "USPS Passport Acceptance",
      address: "6304 E Frontage Rd",
      city: "Merriam",
      state: "KS",
      zip: "66202",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Merriam — about 3 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Convenient option for eastern Shawnee and Merriam residents. Often has shorter wait times than larger facilities.",
      icon: "ri-mail-line",
    },
    {
      id: "shawnee-ks-shawnee-mission-post",
      name: "Shawnee Mission Post Office",
      type: "USPS Passport Acceptance",
      address: "6029 Broadmoor St",
      city: "Mission",
      state: "KS",
      zip: "66202",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Mission — about 5 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Nearby option for northeastern Shawnee and Mission area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "shawnee-ks-johnson-county-clerk",
      name: "Johnson County Clerk's Office",
      type: "County Passport Acceptance",
      address: "111 S Cherry St, Suite 1500",
      city: "Olathe",
      state: "KS",
      zip: "66061",
      phone: "913-715-3300",
      hours: "Mon–Fri 8am–4:30pm (by appointment)",
      distance: "Olathe — about 14 miles south",
      website: "https://www.jocogov.org/",
      websiteLabel: "Johnson County Government",
      notes: "County clerk passport acceptance. Appointment recommended. May have shorter wait times than USPS locations.",
      icon: "ri-government-line",
    },
    {
      id: "shawnee-ks-lenexa-post",
      name: "Lenexa Post Office",
      type: "USPS Passport Acceptance",
      address: "8820 Monrovia St",
      city: "Lenexa",
      state: "KS",
      zip: "66215",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Lenexa — about 4 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Convenient for southern Shawnee and Lenexa residents.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Shawnee before international travel?",
      a: "Yes. Through Fast Passport Center, Shawnee, Kansas travelers can get an expedited passport in as little as 2–9 business days, and emergency processing is available in as fast as 24 hours depending on your eligibility and travel documentation. Start your order online today.",
    },
    {
      q: "How fast can I renew my passport in Shawnee, KS?",
      a: "Fast passport renewal in Shawnee is available through Fast Passport Center in as little as 3 business days with our expedited service. Renewal applications are eligible if your current passport was issued at age 16 or older and within the last 15 years. No office visit required for most renewals.",
    },
    {
      q: "What if my passport expires before my trip to Europe?",
      a: "If your passport expires before your Europe trip, don't wait. Most European countries require at least 3 months of passport validity beyond your planned stay. Fast Passport Center can expedite your passport renewal so you don't miss your flight from MCI.",
    },
    {
      q: "Is there a passport agency in Shawnee, Kansas?",
      a: "Shawnee does not have a regional passport agency. The closest regional passport center is the Arkansas Passport Center in Hot Springs, Arkansas (about 370 miles south). Fast Passport Center is the faster and more convenient solution for most Shawnee and Johnson County residents — no road trip required.",
    },
    {
      q: "Can I expedite a child passport in Shawnee?",
      a: "Yes. Child passport expediting in Shawnee is possible through Fast Passport Center, but child passports for minors 15 and under require an in-person acceptance step with parental consent. We provide a clear checklist and instructions.",
    },
    {
      q: "How long does a standard passport take in Shawnee?",
      a: "If you apply through a standard post office acceptance facility in Shawnee, processing times run 6–13 weeks — sometimes longer during peak travel season. If your travel is sooner than that, you need expedited processing. Fast Passport Center offers Shawnee travelers processing as fast as 24 hours.",
    },
    {
      q: "What airports do Shawnee passport holders typically fly from?",
      a: "Kansas City International Airport (MCI) is the primary airport for Shawnee travelers, just 30 miles north with direct international flights. If your passport isn't in hand, don't book international travel. Fast Passport Center can help you meet your deadline.",
    },
    {
      q: "Can I get a passport renewal near me in Shawnee without visiting an office?",
      a: "Yes. Most Shawnee adults who are renewing a passport can do so entirely by mail — no in-person visit required. Start your order online with Fast Passport Center, complete your documents at home, and ship them overnight from any FedEx or UPS location in Shawnee.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Shawnee", address: "22300 W 66th St, Shawnee, KS 66226", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS — Shawnee", address: "15700 Shawnee Mission Pkwy, Shawnee, KS 66217", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Shawnee", address: "15700 Shawnee Mission Pkwy, Shawnee, KS 66217", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 8 AM – 8 PM" },
    { name: "Walgreens — Merriam", address: "8701 Johnson Dr, Merriam, KS 66202", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS — Lenexa", address: "15100 W 87th St, Lenexa, KS 66219", hours: "Daily 7 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Mission Driver License Office",
      address: "6507 Johnson Dr, Mission, KS 66202",
      hours: "Mon–Fri 7 AM – 5:45 PM",
      note: "Johnson County DMV office closest to Shawnee. Driver licenses, REAL ID, ID cards. Appointment recommended.",
      featured: true,
    },
    {
      name: "Olathe Driver License Office",
      address: "13500 S Mur-Len Rd, Suite B, Olathe, KS 66062",
      hours: "Mon–Fri 7 AM – 5:45 PM",
      note: "Alternative Johnson County DMV for southern Shawnee residents. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "Primary international airport — 30 miles north",
      address: "1 International Sq, Kansas City, MO 64153",
      note: "MCI is the closest major airport for Shawnee travelers. Direct international flights available. Busiest travel seasons are May–August and November–January — plan passport needs well in advance.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport Website",
      featured: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Flying from MCI in 24–72 hours? Our emergency courier service is designed for urgent, last-minute travel from Shawnee and the Kansas City metro.",
      bullets: ["As fast as 24 hours", "Reserved agency submission slots", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Shawnee and Johnson County travelers renew fast — passport expired before trip is one of our most common urgent requests.",
      bullets: ["Eligible for expedited processing", "Ship from any FedEx or UPS in Shawnee", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport before a trip? We guide Shawnee travelers through Form DS-64 and the replacement process — urgent timelines available.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passport expedited service for Shawnee families — minors under 16 require in-person acceptance and parental consent. We provide clear instructions and checklists.",
      bullets: ["Both parents must typically consent", "Clear checklist provided", "Expedited options after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Shawnee residents — we guide you through the acceptance clerk process and handle expedited processing.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Passport Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — we submit through reserved agency channels, not public lines.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, second passports for frequent travelers — all handled with the same expedited courier access.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Shawnee, Kansas travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Shawnee residents needing passports faster than standard government mail timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Shawnee, KS residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement service for Shawnee travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Shawnee families with minors under 16." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Shawnee travelers often assume 6–8 weeks is safe — it's not. Government processing has stretched to 10–14+ weeks during peak travel season. Apply as soon as you book your trip." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. We provide exact specs and can catch these issues before documents are submitted." },
    { icon: "ri-file-damage-line", title: "Incomplete or Incorrect Forms", description: "One wrong date, one missing signature — your application gets sent back and you lose weeks. Our checklist catches errors before submission." },
    { icon: "ri-calendar-close-line", title: "Assuming the Post Office is Fast Enough", description: "Standard USPS passport processing out of Shawnee runs 6–13 weeks. If your trip is in under 10 weeks, standard processing is a gamble. Use our courier service instead." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch Across Documents", description: "Your passport name must match your airline ticket exactly. Middle names, hyphens, and suffixes cause more rejections than you'd expect." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Shawnee travel date. Complete your secure order online — takes just a few minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We confirm your details and send you a personalized document checklist — exactly what you need, nothing more." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Shawnee", description: "Drop off at any FedEx or UPS in Shawnee or the KC metro — most locations are open evenings and weekends." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit your application through our reserved passport agency slots — bypassing the public appointment system entirely." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport is Completed", description: "Your passport is completed within the timeframe you selected and shipped back to your Shawnee address." },
  ],
  processingOptions: [
    {
      speed: "24", unit: "Hours*", label: "Regional Agency Processing",
      tag: "Emergency Only", tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required", "Life-or-death emergencies only", "Expect to wait all day or return next day"],
      highlight: false, emergency: true,
    },
    {
      speed: "2–9", unit: "Business Days", label: "Fast Passport Center",
      tag: "Most Popular", tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Document review included", "Dedicated agent assigned", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5", unit: "Weeks", label: "Fast Passport Center",
      tag: "Standard Expedited", tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Document review included"],
      highlight: false, smartSaver: true,
    },
    {
      speed: "1–2", unit: "Months", label: "Self-Service (Post Office)",
      tag: "Slowest", tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access", "In-person clerk appointment required", "No document review", "No dedicated agent", "Not suitable if travel is within 10 weeks"],
      highlight: false, muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots at Arkansas Passport Center", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Hot Springs, AR (5.5 hours)", fpc: "Ship documents overnight from Shawnee" },
    { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Lenexa", route: "/cities/lenexa" },
    { name: "Fast passport renewal in Overland Park", route: "/cities/overland-park" },
    { name: "Emergency passport help near Olathe", route: "/cities/olathe" },
    { name: "Rush passport service in Merriam, KS", route: "/merriam" },
    { name: "Fast passport renewal for all of Johnson County", route: "/states/kansas" },
  ],
  fpcOfficeNote: "After signing up online, we send your personalized checklist and shipping instructions. Ship your documents overnight from any FedEx or UPS location in Shawnee or the Kansas City metro area — most are open evenings. No office visit to our facility required for most services.",
  fpcOfficeDistance: "Serving Shawnee and all of Johnson County remotely",
  serviceAreaIntro: "Whether you are in Shawnee, Lenexa, Merriam, Overland Park, or anywhere in Johnson County, Fast Passport Center makes expedited passport processing simple — start online, ship overnight, and we handle the rest.",
  nearbyCitiesIntro: "We serve all Shawnee and Johnson County zip codes. Anywhere in the Kansas City metro — ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Shawnee, Kansas as simple as possible. Most Shawnee clients never visit an office.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Shawnee travelers. Fast Passport Center reviews your documents before submission to catch these issues.",
  testimonialsIntro: "Real reviews from Shawnee and Johnson County travelers who needed their passports fast and trusted Fast Passport Center.",
  faqIntro: "The most common questions Shawnee and Johnson County travelers ask about emergency and expedited passport services.",
  statePageRoute: "/states/kansas",
  statePageName: "Kansas",
};